export const useSecureImage = (url: any) => {
  const runtimeConfig = useRuntimeConfig()
  return url ? url.replace('http://', 'https://') : runtimeConfig.public.defaultProductImage;
}